import { Model } from '@hub-components';
import { SnapshotSharingPermissions } from './snapshot-sharing-permissions.model';

export interface SnapshotJSON {
  id: string;
  item_id: string;
  item_name: string;
  type: string;
  public_uuid?: string;
  overview_note?: string;
  breakdown_note?: string;
  sharing_permissions?: {
    overview?: boolean;
    breakdown?: boolean;
    comparisons?: boolean;
    breakdown_cost_based_metrics?: boolean;
    breakdown_viewability_metrics?: boolean;
  };
}

export class Snapshot extends Model {
  id: string;
  itemId: string;
  itemName: string;
  type: string;
  publicUuid?: string;
  overviewNote?: string;
  breakdownNote?: string;
  sharingPermissions?: SnapshotSharingPermissions;

  constructor(obj: Partial<SnapshotJSON> = {}) {
    super(obj);

    if (obj.sharing_permissions) {
      this.sharingPermissions = new SnapshotSharingPermissions(obj.sharing_permissions);
    }
  }

  public asJson(): SnapshotJSON {
    return {
      id: this.id,
      item_id: this.itemId,
      item_name: this.itemName,
      type: this.type,
      public_uuid: this.publicUuid,
      overview_note: this.overviewNote,
      breakdown_note: this.breakdownNote,
      sharing_permissions: this.sharingPermissions?.asJson(),
    };
  }
}
